import styled from "styled-components";

export const StyledSideBarBlock = styled.div`
  border-top: 1px solid #000;
  width: 100%;

  & p:last-child {
    margin-bottom: 0;
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
          padding-top: ${props.theme.spacePx(breakpoint, 10)};
          
          & > div {
            margin-bottom: ${props.theme.spaceFontBottom(
              breakpoint,
              6,
              "body"
            )};
          }
        `;
    })}
`;

import React from "react";

export const SideBarBlock = ({ children }: { children: React.ReactNode }) => {
  return (
    <StyledSideBarBlock>
      <div>{children}</div>
    </StyledSideBarBlock>
  );
};

export default SideBarBlock;
